export const Residents = 'Residents';
export const VacantAddressesList = 'VacantAddressesList';
export const VehiclesList = 'VehiclesList';
